export default __webpack_public_path__ + "static/media/Rajastan_1.6891ad83.png";